module.exports = __webpack_public_path__ + "static/media/02_crear_combo_base_rectangular_empeza_a_crear.fb1d13de.png";